import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

    {
        path: "/:slug?",
        name: "defaultPage",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/:slug?/m=:montant?",
        name: "defaultPage_",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/:slug?/m=:montant?/r=:reason?",
        name: "_defaultPage_",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/:slug?/m=:montant?/i=:indice?/t=:tel?/n=:nom?/p=:prenom?/e=:email?/r=:reason?",
        name: "defaultPage__",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/:slug?/m=:montant?/i=:indice?/t=:tel?/n=:nom?/p=:prenom?/e=:email?/r=:reason?/k=:key?",
        name: "defaultPage__2",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/:slug?/m=:montant?/i=:indice?/t=:tel?/n=:nom?/p=:prenom?/e=:email?/r=:reason?/k=:key?/l=:redirect_key?",
        name: "defaultPage__3",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/nourahama/:slug?",
        name: "defaultPage___",
        component: () => import(/* webpackChunkName: "DefaultPage" */ "../pages/DefaultPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/ref/:reference?",
        name: "refPage",
        component: () => import(/* webpackChunkName: "ReferencePage" */ "../pages/ReferencePage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/return-payment/:reference?",
        name: "returnPaymentPage",
        component: () => import(/* webpackChunkName: "ReferencePage" */ "../pages/ReturnPaymentPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/payment/:slug?/:name?",
        // name: "personalPagePayment",
        component: () => import(/* webpackChunkName: "PaymentPage" */ "../pages/PaymentPage"),

    },
    {
        path: "/recu/:ref?",
        name: "receiptPayment",
        component: () => import(/* webpackChunkName: "Receipt" */ "../pages/Receipt"),
        meta: {
            title: 'Voilà mon reçu!',
            metaTags: [
                {
                    name: 'description',
                    content: 'Téléchargez votre reçu pour le paiement effectué via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }, 
                {
                    property: 'og:description',
                    content: 'Téléchargez votre reçu pour le paiement effectué via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },

    },
    {
        path: "/business/:numero?",
        name: "mutilbusinessPage",
        component: () => import(/* webpackChunkName: "mutilbusinessPage" */ "../pages/mutilbusinessPage"),
        meta: {
            title: 'Retrouve mes liens de paiement ici',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },

    },
    {
        path: "/a/:reference?",
        name: "payWithAPaym",
        component: () => import(/* webpackChunkName: "mutilbusinessPage" */ "../pages/payWithAPaymPage"),
        meta: {
            title: 'Paye moi comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },

    },
    {
        path: "/orabank/form-dev",
        name: "orabankFormulaire",
        component: () => import(/* webpackChunkName: "PaymentPage" */ "../pages/FormulaireCartePage"),
        meta: {
            title: 'Formulaire de test - Orabank APIs',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "/sgi-form/:slug?",
        name: "nsiaFinanceFormulaire",
        component: () => import(/* webpackChunkName: "PaymentPage" */ "../pages/NSIAFinancePage"),
        meta: {
            title: 'Formulaire NSIA Finance - 2e proposition',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez cliquer sur mon lien pour me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym.'
                }
            ]
        },
    },
    {
        path: "*",
        component: () => import(/* webpackChunkName: "Erreur404" */ "../pages/Erreur404")
    }
];

const router = new VueRouter({
    routes,
    mode: "history",
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title ;
    next()
}) ;

router.afterEach(to => {
    localStorage.setItem("route", to.name);
});

export default router;
